import { useEffect, useRef, useState } from "react";
import { CustomTabs } from "../../components/CustomTabs"
import { TitleBar } from "../../components/TitleBar"
import useAuth from "../../hook/useAuth";
import { AddClass } from "../../components/AddClass";
import { getTeacherAllClasses } from "../../services/Class";
import { useNavigate } from "react-router-dom";
import { AddStudent } from "../../components/AddStudent";

const tabs = ["Classes"];

export const TeacherDashboard = () => {
    const { auth }: any = useAuth();
    const navigate = useNavigate();
    const [activeIndex, setActiveIndex] = useState<number>(0);
    const [showAddNewClassPopup, setShowAddNewClassPopup] = useState<boolean>(false);
    const [allClasses, setAllClasses] = useState<any[]>([]);
    const [classDataIsLoaded, setClassDataIsLoaded] = useState<boolean>(false);
    const [refreshClassList, setRefreshClassList] = useState<boolean>(true);
    const [selectedClass, setSelectedClass] = useState<number>(0);
    const [showAddNewStudentPopup, setShowAddNewStudentPopup] = useState<boolean>(false);
    const [dropdownOpen, setDropdownOpen] = useState<number | null>(null);
    const dropDownRefs = useRef<(HTMLDivElement | null)[]>([]);

    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (
                dropdownOpen !== null &&
                dropDownRefs.current[dropdownOpen] &&
                !dropDownRefs.current[dropdownOpen]?.contains(event.target as Node)
            ) {
                setDropdownOpen(null);
            }
        }

        document.addEventListener("click", handleClickOutside); // 👈 use click, not mousedown
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, [dropdownOpen]);


    useEffect(() => {
        if (auth?.id && refreshClassList) {
            setClassDataIsLoaded(false);
            getTeacherAllClasses(auth?.id)
                .then((data) => {
                    setAllClasses(data);
                    setRefreshClassList(false);
                    setClassDataIsLoaded(true);
                })
                .catch((error) => {
                    console.error(error);
                })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [auth, refreshClassList])



    const hanbleTabChange = (index: number) => {
        setActiveIndex(index);
    }

    return (
        <>
            <div className="p-4 min-h-screen">
                <TitleBar
                    title={"Welcome, " + auth?.givenname}
                    subTitle="Teacher Dashboard"
                />

                <div className="w-full py-8">
                    <CustomTabs
                        tabs={tabs}
                        activeIndex={activeIndex}
                        onChange={(index) => hanbleTabChange(index)}
                    />

                    {
                        activeIndex === 0 && (
                            <div className="w-full px-10">
                                <div className="w-full mt-4 flex justify-end items-center border-b border-gray-200 pb-4">
                                    <button
                                        className="py-2 px-4 bg-primary text-white text-sm font-medium rounded-md outline-none hover:bg-blue-600 shadow-md"
                                        onClick={() => setShowAddNewClassPopup(true)}
                                    >
                                        Add new class
                                    </button>
                                </div>

                                <div className="space-y-4 my-4">
                                    {
                                        allClasses?.map((item: any, index: number) => (
                                            <div key={index} className="md:flex items-center justify-between bg-white shadow rounded-lg p-4 border hover:shadow-md transition">
                                                <div className="flex items-center space-x-4">

                                                    <img src="/images/class-img.png" alt="class-img" className="w-16 h-16 rounded-md" />



                                                    <div>
                                                        <h3 className="font-semibold text-gray-800 uppercase">{item?.className}</h3>
                                                        <p className="text-sm">
                                                            <span className="font-medium">Courses:</span>{" "}
                                                            <span className="text-primary">
                                                                {item?.courseName}
                                                            </span>
                                                        </p>
                                                        <p className="text-sm">
                                                            <span className="font-medium">Students:</span>{" "}
                                                            <span className="text-red-500">{item?.totalStudent} students</span>
                                                        </p>
                                                    </div>
                                                </div>


                                                <div className="flex items-center space-x-3 max-md:mt-2">
                                                    <button
                                                        className="max-md:w-full px-4 py-2 border rounded-md text-primary border-primary hover:bg-blue-50"
                                                        onClick={() => {
                                                            setSelectedClass(item?.classId)
                                                            setShowAddNewStudentPopup(true)
                                                        }}
                                                    >
                                                        Add students
                                                    </button>
                                                    <div ref={(el) => (dropDownRefs.current[index] = el)} className="relative">

                                                        <button className="text-gray-600 hover:text-gray-800" onClick={() => setDropdownOpen(dropdownOpen === index ? null : index)}>
                                                            <span className="material-symbols-outlined text-xl">
                                                                more_horiz
                                                            </span>
                                                        </button>

                                                        {dropdownOpen === index && (
                                                            <div className="absolute w-40 bg-white shadow-lg border rounded-md top-[42px] -right-[53px]">
                                                                <ul className="text-sm text-gray-700">

                                                                    <li
                                                                        className="px-4 py-2 hover:bg-gray-100 hover:underline cursor-pointer"
                                                                        onClick={() => {
                                                                            navigate("/teacher/class/students", { state: { id: item?.classId, title: item?.className, selectedSideBar: 0 } })
                                                                        }}
                                                                    >
                                                                        Students
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </div>

                                {
                                    !classDataIsLoaded && (
                                        <div className="flex items-center justify-center w-full p-2">
                                            <div className="mb-4 h-12 w-12 animate-spin rounded-full border-4 border-gray-300 border-t-primary" />
                                        </div>
                                    )
                                }

                                {
                                    (classDataIsLoaded && allClasses.length === 0) && (
                                        <div className="flex items-center justify-center w-full p-2">
                                            <span className="text-lg text-gray-400">No class found!</span>
                                        </div>
                                    )
                                }

                            </div>
                        )
                    }


                </div>
            </div>
            {
                showAddNewClassPopup && (
                    <AddClass showPopup={showAddNewClassPopup} setShowPopup={setShowAddNewClassPopup} setRefreshClassList={setRefreshClassList} />
                )
            }


            {
                showAddNewStudentPopup && (
                    <AddStudent showPopup={showAddNewStudentPopup} setShowPopup={setShowAddNewStudentPopup} classId={selectedClass} setRefreshClassList={setRefreshClassList} />
                )
            }


        </>

    )
}